export default "__VITE_ASSET__Bm09JzU4__"